<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { usePartnerStore } from '@/stores/usePartnerStore'
import { storeToRefs } from 'pinia'
import OpportunityCreate from '../opportunities/OpportunityCreate.vue'
import EventCreate from '@/components/features/events/EventCreate.vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import IconSuiteCase from '@/assets/icons/suitcase-lg.svg'

import { EnvelopeIcon, CalendarIcon } from '@heroicons/vue/24/outline'
import TodoModal from '@/components/features/todos/TodoModal.vue'
import CallDoNotDisturb from '@/components/features/calls/CallDoNotDisturb.vue'
import AddToCampaignButton from '@/components/common/buttons/AddToCampaignButton.vue'
import { useCampaignStore } from '@/stores/useCampaignStore'
import {  ListBulletIcon } from '@heroicons/vue/24/outline'
import IconWithTooltip from '@/components/common/ui/IconWithTooltip.vue'

const campaignStore = useCampaignStore()
const { loadingAddCallSessions } = storeToRefs(campaignStore)
const props = defineProps<{ partnerId: number }>()

const partnerStore = usePartnerStore()
const { partner } = storeToRefs(partnerStore)
const company = ref()

const showTodoModal = ref(false)

const openTodoModal = async () => {
  if(props.partnerId)
    company.value = await partnerStore.fetchCompanyByOdooRef(props.partnerId)
  showTodoModal.value = true
}

const closeTodoModal = () => {
  company.value = undefined
  showTodoModal.value = false
}

const handleTodoCreated = () => {
  showTodoModal.value = false
}

onMounted(() => {
  partnerStore.getPartnerById(props.partnerId)
})
</script>

<template>
  <div class="flex gap-2" v-if="partner">
    <div class="tooltip" data-tip="Nouveau rendez-vous">
      <EventCreate>
        <template #trigger="{ openModal }">
          <ButtonDaisy text="" :icon="CalendarIcon" @click="openModal" />
        </template>
      </EventCreate>
    </div>
    <IconWithTooltip :text="'Nouveau To Do'" @click="openTodoModal">
      <ListBulletIcon class="h-4 w-4"></ListBulletIcon>
    </IconWithTooltip>
    <div v-if="partner.email" class="tooltip" :data-tip="partner.email">
      <a :href="'mailto:' + partner.email">
        <ButtonDaisy text="" :icon="EnvelopeIcon" />
      </a>
    </div>
    <div class="tooltip" data-tip="Nouvelle affaire">
      <OpportunityCreate>
        <template #trigger="{ openModal }">
          <button-daisy @click="openModal" text="">
            <component :is="IconSuiteCase" class="h-4 w-4" />
          </button-daisy>
        </template>
      </OpportunityCreate>
    </div>
    <AddToCampaignButton :selectedPartners="[partner]" :loader="loadingAddCallSessions" />
    <div class="tooltip" data-tip="Ne plus contacter cette société">
      <CallDoNotDisturb :partner-id="partnerId" />
    </div>
    <TodoModal
      v-if="company"
      :showModal="showTodoModal"
      mode="create"
      @close="closeTodoModal"
      @created="handleTodoCreated"
      :company="company"
    />
  </div>
  <div v-else class="skeleton opacity-30 h-[390px] m-2"></div>
</template>
